import React from "react";
import {ScrollTest} from "../../component/ScrollTest";
import { commoditys } from "./commodity";






export default function Home() {
    return(
        <div>
            <HomeSection1/>
            <HomeSection2/>
        </div>
    )
}

function HomeSection1() {
    return(
        <div className="background">
            <div className="home_img">
            <div className="mainText">
                <h1>MEMORY 紀錄屬於你的故事</h1>
            </div>
            </div>
        </div>
    )
}
function HomeSection2() {
    return(
        <div className="background products">
            <div className="home_img">
                <div className="white_bg flex_column_start_center">
                    <div className="title">
                        <h4>喜歡的商品，放上心愛的照片，讓美好的時刻陪伴您的人生</h4>
                    </div>
                    <div className="flex_row_center_center width90vw">
                        {commoditys.map((el, index)=> (
                            <ScrollTest
                                key={index}
                                title={
                                    <div className="product">
                                        <div className="product_title">
                                            <div className="product_img_container">
                                                <img className="product_img" src={require('../../assets/img/homeSection1.jpg')} alt={el.title}/>
                                            </div>
                                            <div className="product_desc flex_column_center_center">
                                                <p className="small_title">{el.title}</p>
                                                {el.desc1}<br/>{el.desc2}
                                            </div>
                                        </div>
                                    </div>
                                }/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}